import { FileUpload } from '../features/Forms/FileUpload';
import { Survey } from '../interfaces/survey.interface';
import { Assessment } from '../interfaces/assessment.interface';
import User from '../interfaces/users.interface';
import { USER_TYPES } from '../services/user';

// Content owners see only vendor-public evidence, and only once submitted for assessment; extracted so the workspace shows the same list.
export function filterEvidenceForUser(
  files: FileUpload[],
  user: User | undefined,
  survey: Survey | undefined,
  assessment: Assessment | undefined,
): FileUpload[] {
  if (user?.type !== USER_TYPES.CONTENT_OWNER) return files;
  if (survey?.status === 'submittedForAssessment' || assessment) {
    return files.filter(file => file.isPublic);
  }
  return [];
}
